<div class="u4-toolbar">
  <div class="u4-toolbar__first-row">
    <div class="u4-toolbar__section-left">
      <div class="u4-toolbar__results">
        <strong>{{this.results}}</strong> {{ resultsLabel }}
        <span *ngIf="loading" class="u4-spinner u4-spinner--sm"></span>
      </div>
    </div>
    <div class="u4-toolbar__form">
      <ng-content></ng-content>
    </div>
    <div class="u4-toolbar__help">
      <a  href="javascript:void(0)" *ngIf="hint" (click)="showHint($event, hint)">
        {{hintText}}
      </a>
    </div>
  </div>
</div>
